/* ARG HEALTHCARE — collection filter rail. Lean build. */
(function () {
  "use strict";
  var CLAMP = 10, KEY = "cx-open-facets";
  var d = document, B = d.body;

  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  function get() { try { return JSON.parse(sessionStorage.getItem(KEY) || "{}"); } catch (e) { return {}; } }
  function set(o) { try { sessionStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }

  function accordion(rail) {
    var st = get();
    $$("[data-cx-f]", rail).forEach(function (f) {
      var t = $("[data-cx-t]", f), b = $("[data-cx-b]", f);
      if (!t || !b || t.dataset.on) return;
      t.dataset.on = "1";

      var k = t.textContent.trim().slice(0, 30);
      if (st[k] === false && !f.classList.contains("is-act")) {
        f.classList.add("is-shut"); b.style.height = "0px";
      } else b.style.height = "auto";

      function flip(e) {
        if (e) e.preventDefault();
        var shut = f.classList.contains("is-shut");
        if (shut) {
          f.classList.remove("is-shut");
          b.style.height = b.scrollHeight + "px";
          setTimeout(function () { if (!f.classList.contains("is-shut")) b.style.height = "auto"; }, 320);
        } else {
          b.style.height = b.scrollHeight + "px";
          void b.offsetHeight;
          f.classList.add("is-shut");
          b.style.height = "0px";
        }
        var s = get(); s[k] = shut; set(s);
      }
      t.addEventListener("click", flip);
      t.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") flip(e);
      });
    });
  }

  function showAll(rail) {
    $$(".cx-list", rail).forEach(function (ul) {
      if (ul.dataset.on) return;
      var li = $$(":scope > li", ul);
      if (li.length <= CLAMP) return;
      ul.dataset.on = "1";
      ul.classList.add("is-clip");

      var beyond = false;
      li.forEach(function (x, i) {
        if (i >= CLAMP) {
          if (x.classList.contains("is--selected")) beyond = true;
          x.classList.add("is-hid");
        }
      });

      var btn = d.createElement("button");
      btn.type = "button";
      btn.className = "cx-more";
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg><span>Show all</span>';
      var lbl = $("span", btn);

      btn.addEventListener("click", function () {
        var open = !ul.classList.toggle("is-clip");
        btn.classList.toggle("is-open", open);
        lbl.textContent = open ? "Show less" : "Show all";
        var b = btn.closest("[data-cx-b]");
        if (b) b.style.height = "auto";
      });

      ul.parentNode.appendChild(btn);
      if (beyond) btn.click();
    });
  }

  /* ---- price range: dual handle + number boxes ---- */
  function price(rail) {
    $$("[data-cx-price]", rail).forEach(function (w) {
      if (w.dataset.on) return;
      w.dataset.on = "1";

      var lo = $("[data-cx-lo]", w), hi = $("[data-cx-hi]", w),
          nlo = $("[data-cx-nlo]", w), nhi = $("[data-cx-nhi]", w),
          fill = $(".cx-price__fill", w), out = $("[data-cx-out]", w),
          go = $("[data-cx-apply]", w);

      var MIN = +w.dataset.min || 0, MAX = +w.dataset.max || 0;
      var STEP = +w.dataset.step || 1;
      var GTE = w.dataset.gte, LTE = w.dataset.lte;
      var start = [+lo.value, +hi.value];

      var fmt;
      try {
        fmt = new Intl.NumberFormat(undefined, {
          style: "currency", currency: w.dataset.iso || "INR", maximumFractionDigits: 0
        });
      } catch (e) { fmt = { format: function (n) { return n; } }; }

      function clamp(n) { return Math.min(MAX, Math.max(MIN, isNaN(n) ? MIN : n)); }
      function snap(n) {
        var v = MIN + Math.round((clamp(n) - MIN) / STEP) * STEP;
        return clamp(v);
      }
      function pct(n) { return MAX > MIN ? ((n - MIN) / (MAX - MIN)) * 100 : 0; }

      function paint(ea, eb) {
        var a = ea != null ? ea : +lo.value,
            b = eb != null ? eb : +hi.value;
        fill.style.left = pct(a) + "%";
        fill.style.width = Math.max(0, pct(b) - pct(a)) + "%";
        out.innerHTML = "<b>" + fmt.format(a) + "</b> — <b>" + fmt.format(b) + "</b>";
        if (go) go.disabled = (a === start[0] && b === start[1]);
      }

      // handles can't cross
      function fromSlider(which) {
        var a = +lo.value, b = +hi.value;
        if (a > b) { if (which === "lo") lo.value = b; else hi.value = a; }
        nlo.value = lo.value; nhi.value = hi.value;
        paint();
      }
      lo.addEventListener("input", function () { fromSlider("lo"); });
      hi.addEventListener("input", function () { fromSlider("hi"); });

      function fromBox() {
        var a = clamp(parseInt(nlo.value, 10)), b = clamp(parseInt(nhi.value, 10));
        if (isNaN(parseInt(nhi.value, 10))) b = MAX;
        if (a > b) { var t = a; a = b; b = t; }
        lo.value = snap(a); hi.value = snap(b);
        nlo.value = a; nhi.value = b;
        paint(a, b);
      }
      [nlo, nhi].forEach(function (n) {
        n.addEventListener("change", fromBox);
        n.addEventListener("keydown", function (e) {
          if (e.key === "Enter") { e.preventDefault(); fromBox(); apply(); }
        });
      });

      function apply() {
        var a = clamp(parseInt(nlo.value, 10)),
            b = clamp(parseInt(nhi.value, 10));
        if (isNaN(parseInt(nhi.value, 10))) b = MAX;
        if (a > b) { var t = a; a = b; b = t; }
        var u = new URL(window.location.href);
        u.searchParams.delete("page");
        if (a > MIN) u.searchParams.set(GTE, a); else u.searchParams.delete(GTE);
        if (b < MAX) u.searchParams.set(LTE, b); else u.searchParams.delete(LTE);
        window.location.href = u.toString();
      }
      if (go) go.addEventListener("click", apply);

      paint();
    });
  }

  /* ---- add a "View Now" button to each card ---- */
  function viewBtn(scope) {
    $$(".bee-collection-page .bee-product", scope || d).forEach(function (card) {
      if ($(".cx-view", card)) return;
      var link = card.querySelector("a[data-pr-href], .bee-product-title a");
      var info = $(".bee-product-main-info", card) || $(".bee-product-info", card);
      if (!link || !info) return;

      var a = d.createElement("a");
      a.className = "cx-view";
      a.href = link.getAttribute("href");
      a.innerHTML = '<span>View Now</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/></svg>';
      info.appendChild(a);
    });
  }

  function init() {
    viewBtn();
    var rail = $(".cx-rail");
    if (!rail) return;
    accordion(rail);
    showAll(rail);
    price(rail);
  }

  // open / close + loading state, delegated once
  d.addEventListener("click", function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest("[data-cx-open]")) { B.classList.add("cx-open"); return; }
    if (t.closest("[data-cx-close]")) { B.classList.remove("cx-open"); return; }
    if (t.closest(".cx-rail a, .bee-active-filters a")) {
      var m = $(".bee-main-area");
      if (m) {
        m.classList.add("is-busy");
        setTimeout(function () { m.classList.remove("is-busy"); }, 2500);
      }
    }
  });

  d.addEventListener("keydown", function (e) {
    if (e.key === "Escape") B.classList.remove("cx-open");
  });

  if (d.readyState === "loading") d.addEventListener("DOMContentLoaded", init);
  else init();

  // the theme refills [data-replace-filter] after AJAX filtering
  var grid = $(".bee-collection-page .bee-main-area");
  if (grid && window.MutationObserver) {
    new MutationObserver(function () { setTimeout(viewBtn, 40); })
      .observe(grid, { childList: true, subtree: true });
  }

  var m = $("[data-replace-filter]");
  if (m && window.MutationObserver) {
    new MutationObserver(function () { setTimeout(init, 40); })
      .observe(m, { childList: true, subtree: true });
  }
})();